export default "__VITE_ASSET__ByWzcm4F__"